(ns bec-cljs-common.booking
  (:require [re-frame.core :as rf]))


(rf/reg-sub ::url-head
  (fn [db _]
    (-> db :config :booking :url-head)))


(rf/reg-sub ::authorization
  (fn [db _]
    (-> db :config :booking :authorization)))


(defn get-url-head []
  @(rf/subscribe [::url-head]))


(defn get-authorization []
  @(rf/subscribe [::authorization]))

